// Offline support has been removed from CloudSafe.
//
// This module used to register a caching service worker for the (now removed)
// "Prepare for offline" feature. That SW cached the app shell and caused devices
// to keep serving a stale JS bundle after new deploys. We now actively tear it
// down: unregister every service worker and delete its caches on app load.

export function killServiceWorker() {
  if (typeof navigator === 'undefined') return;
  try {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations()
        .then((regs) => regs.forEach((reg) => reg.unregister().catch(() => {})))
        .catch(() => {});
    }
    if (typeof caches !== 'undefined' && caches.keys) {
      caches.keys()
        .then((keys) => keys.filter((k) => k.startsWith('cloudsafe-')).forEach((k) => caches.delete(k)))
        .catch(() => {});
    }
  } catch { /* no-op */ }
}

// Back-compat no-ops for any remaining importers.
export function register() { killServiceWorker(); }
export function unregister() { killServiceWorker(); }

export default killServiceWorker;
